import { render, staticRenderFns } from "./SaveCustomer.vue?vue&type=template&id=58602f4e&scoped=true&"
import script from "./SaveCustomer.vue?vue&type=script&lang=js&"
export * from "./SaveCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58602f4e",
  null
  
)

export default component.exports